import React from 'react';
import styled from '@emotion/styled';

import { COLOR_GREEN } from 'client/components/MarketingPagesShared/styles';
import { MarketingImage } from 'client/components/MarketingPagesShared/MarketingImage';
import { MarketingVideo } from 'client/components/MarketingPagesShared/MarketingVideo';
import { useT } from 'client/i18n/hooks/useT';
import { SCREEN_BREAKPOINTS } from '../constants';
import { AdsWaveSVG } from './Icons';

// Fake data until we have real data to show
const VIDEO_DATA = {
  height: 546,
  width: 970,
  imagePath: 'span/ads-by-anchor-video-thumbnail',
  videoId: 'YZ_oYxqWL9g',
};

const VideoSection = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: ${SCREEN_BREAKPOINTS.TABLET}px) {
    margin: 0 auto;
  }
`;

const VideoTitle = styled.h3`
  margin: 0 0 100px;
  color: ${COLOR_GREEN};
  font-weight: 900;
  font-size: 6rem;
  line-height: 4.4rem;
  text-align: center;

  @media (max-width: ${SCREEN_BREAKPOINTS.TABLET}px) {
    margin: 0 0 50px;
    line-height: 1;
  }

  @media (max-width: 600px) {
    margin: 0 0 25px;
    font-size: 2.8rem;
  }
`;

const VideoWrapper = styled.div`
  width: 100%;
  max-width: 1064px;
  margin: 0 auto;
  background: #24203f;

  @media (max-width: ${SCREEN_BREAKPOINTS.TABLET}px) {
    width: 100%;
  }
`;

const AdsWaveSVGContainer = styled.div`
  position: absolute;
  bottom: -8px;
  width: 100%;

  svg {
    width: 100%;
    height: 100%;
  }
  @media (max-width: ${SCREEN_BREAKPOINTS.TABLET}px) {
    bottom: -6px;
  }
`;

const ContentWrapper = styled.div`
  z-index: 1;
  width: 100%;
  max-width: 1064px;
  padding: 24px;
  padding-bottom: calc(100vw * 0.1);
  @media (max-width: ${SCREEN_BREAKPOINTS.TABLET}px) {
    padding-bottom: 50px;
  }
`;

export const Video = () => {
  const t = useT();
  return (
    <VideoSection>
      <ContentWrapper>
        <VideoTitle>
          {t(
            'AdsByAnchorScreen.Video.SectionTitle',
            'Ads by Anchor overview',
            'Ads by Anchor page video section title'
          )}
        </VideoTitle>
        <VideoWrapper>
          <MarketingVideo
            height={VIDEO_DATA.height}
            title={t(
              'AdsByAnchorScreen.Video.VideoTitle',
              'Introducing Ads by Anchor',
              'Ads by Anchor page video title'
            )}
            width={VIDEO_DATA.width}
            youTubeVideoId={VIDEO_DATA.videoId}
          >
            <MarketingImage
              alt={t(
                'AdsByAnchorScreen.Video.VideoDescription',
                'Group of illustrated people recording a podcast',
                'Ads by Anchor page video description'
              )}
              height={VIDEO_DATA.height}
              imagePath={VIDEO_DATA.imagePath}
              width={VIDEO_DATA.width}
            />
          </MarketingVideo>
        </VideoWrapper>
      </ContentWrapper>
      <AdsWaveSVGContainer>
        <AdsWaveSVG />
      </AdsWaveSVGContainer>
    </VideoSection>
  );
};
